export default "__VITE_ASSET__cfb2a96d__"